import { getApiUrls } from './modules/constants.js';
import { postRequest } from './modules/request.js';
import toastr from 'toastr';
import swal from 'sweetalert';

import { 
    handleCnpjCpfField, 
    handlePhoneField, 
    handleGenericField,
    handleFullnameField,
    handleEmailField, 
    checkAllFieldsValidations ,
    checkFirstPageFieldsValidations,
    setFormLoader,
    removeFormLoader,
    clearForm,
} from './modules/form.js';
const form = {
    cnpj: {
        el: document.getElementById('cnpj'),
        isValid: false,
        required: true,
    },
    phone: {
        el: document.getElementById('phone'),
        isValid: false,
        required: true,
    },
    name: {
        el: document.getElementById('name'),
        isValid: false,
        required: true,
    },
    email: {
        el: document.getElementById('email'),
        isValid: false,
        required: true,
    },
    store_name: {
        el: document.getElementById('store-name'),
        isValid: false,
        required: true,
    },
    city: {
        el: document.getElementById('city'),
        isValid: false,
        required: true,
    },
    street: {
        el: document.getElementById('street'),
        isValid: false,
        required: true,
    },
    street_number: {
        el: document.getElementById('street-number'),
        isValid: false,
        required: true,
    },
    neighborhood: {
        el: document.getElementById('neighborhood'),
        isValid: false,
        required: true,
    },
    reference: {
        el: document.getElementById('reference'),
        isValid: true,
        required: false,
    },
    state: {
        el: document.getElementById('state'),
        isValid: true,
        required: true,
    },
    n_pos: {
        el: document.getElementById('n-pos'),
        isValid: true,
        required: true,
    },
};
handleCnpjCpfField(form.cnpj);
handlePhoneField(form.phone);
handleFullnameField(form.name);
handleEmailField(form.email);
handleGenericField(form.store_name);
handleGenericField(form.city);
handleGenericField(form.street);
handleGenericField(form.street_number);
handleGenericField(form.neighborhood);
handleGenericField(form.reference);

import jCaptcha from 'js-captcha';
const captcha = new jCaptcha({
        el: '.jCaptcha',
        canvasClass: 'jCaptchaCanvas',
        canvasStyle: {
            width: 100,
            height: 15,
            textBaseline: 'top',
            font: '15px Arial',
            textAlign: 'left',
            fillStyle: 'darkgray',
        },
        callback: (res, $captchaInputElement, numberOfTries)=> {
            if(res =='success') {
                _sendFormAction();
            }
            if(res == 'error') {
                toastr.error('Captcha inválido');
                captcha.reset();
            }
        }
    });

import { flipCardToBack, flipCardToFront } from './modules/flipCard.js';
const flipToBackButton = document.getElementById('flip-to-back-button');
flipToBackButton.addEventListener('click', ()=> {
    if(!checkFirstPageFieldsValidations(form)) {
        toastr.error('Por favor preencha os campos obrigatórios');
    }
    else {
        if(!document.getElementById('terms').checked) {
            toastr.error('Por favor concorde com os termos');
        }
        else {
            const { SHIPAY_LEAD_URL } = getApiUrls();
            const body = {
                'name': form.name.el.value,
                'email': form.email.el.value,
                'store_cnpj_cpf': form.cnpj.el.value,
                'phone': form.phone.el.value,
            };

            postRequest(SHIPAY_LEAD_URL, body).then().catch((err)=> {
                console.error(err);
            });
            flipCardToBack();
        }
    }
});
const flipToFrontButton = document.getElementById('flip-to-front-button');
flipToFrontButton.addEventListener('click', ()=> {
    flipCardToFront();
});

const sendFormButton = document.getElementById('send-form');
sendFormButton.addEventListener('click', ()=> {
    if(!checkAllFieldsValidations(form)) {
        toastr.error('Por favor preencha os campos obrigatórios!');
    }
    else {
        captcha.validate();
    }
});

const _sendFormAction = ()=> {
    const registrationForm = {
        'user_email': form.email.el.value,
        'user_full_name': form.name.el.value,
        'store_name': form.store_name.el.value,
        'store_cnpj_cpf': form.cnpj.el.value,
        'store_street': form.street.el.value,
        'store_city': form.city.el.value,
        'store_state': form.state.el.value,
        'store_neighborhood': form.neighborhood.el.value,
        'store_street_number': form.street_number.el.value,
        'user_phone': form.phone.el.value,
        'store_pos_number': form.n_pos.el.value,
    };

    if(form.reference.el.value) {
        registrationForm['store_reference'] = form.reference.el.value;
    }

    const { SHIPAY_REGISTRATION_URL } = getApiUrls();

    setFormLoader();
    postRequest(SHIPAY_REGISTRATION_URL, registrationForm).then((res)=> {
        toastr.success("Formulário enviado com sucesso");
        swal('Usuário cadastrado com sucesso',
            'Credenciais para acesso ao painel shipay foram enviadas para o email utilizado no cadastro');
        clearForm();
        removeFormLoader();
    }).catch((err)=> {
        removeFormLoader();
        if(err) {
            const errJSON = JSON.parse(err);
            if(errJSON.message === 'cnpj is not valid') {
                toastr.error('CNPJ inválido');
                return ;
            }
            if(errJSON.message == 'User already in the database' || 
                errJSON.message == 'CNPJ/CPF already in the database') {
                const link_el = document.createElement('div');
                link_el.innerHTML = 'Acesse o painel Shipay em: <a href="https://painel.shipay.com.br" target="_blank">https://painel.shipay.com.br</a>';
                swal({
                    title: 'Usuário já cadastrado na Shipay',
                    content: link_el
                });
                return ;
            }

            toastr.error('Problema ao cadastrar usuário');
        }
    });
};

import { scrollToForm } from './modules/scrollTo.js';
const buttons = document.getElementsByClassName('scroll-to-form');
for(const bt of buttons) {
    bt.addEventListener('click', ()=> {
        scrollToForm();
    });
}

import { loadStatesList, handleCEPField } from './modules/geoServices.js';
loadStatesList();
const cepEl = document.getElementById('cep');
handleCEPField(cepEl, (cepInfo)=> {
    if(!cepInfo || Object.values(cepInfo).length === 0) {
        toastr.error('Cep não encontrado');
    }
    else {
        form.city.el.value = cepInfo.city;
        form.city.isValid = true;
        form.neighborhood.el.value = cepInfo.neighborhood;
        form.neighborhood.isValid = true;
        form.street.el.value = cepInfo.street;
        form.street.isValid = true;
        form.state.el.value = cepInfo.state;
        form.state.isValid = true;
    }
});

import { handleTermsModal } from './modules/modal.js';
handleTermsModal();
